export default __webpack_public_path__ + "static/media/solution_02.2a3c284c.png";